@if (cameraInitializing && !activeStream && !cameraActive && !isNative) {
  <div class="camera-loading">
    <cs-spinner></cs-spinner>
  </div>
}
@if (activeStream || cameraActive) {
  <div class="camera-container" #cameraContainer
    [class.native-mode]="isNative"
    [class.flipped]="cameraFlipped" [class.flipping]="cameraFlipping"
    (touchstart)="onPinchStart($event)" (touchmove)="onPinchMove($event)" (touchend)="onPinchEnd()">
    @if (!isNative && !isBarcodeMode) {
      <div class="camera-flip-inner" #cameraFlipInner>
        <video #videoElement class="camera-face camera-face-front" autoplay playsinline></video>
        <video #videoElementBack class="camera-face camera-face-back" autoplay playsinline></video>
      </div>
    }

    @if (!isNative) {
      <div class="overlay-buttons">
        @if (cameraService.flashSupported) {
          <cs-button class="flash-button" secondary overlay small icon="flash" [class.active]="cameraService.flashEnabled" (click)="toggleFlash()"></cs-button>
        }
        @if (cameraService.cameraInfos.length > 1) {
          <cs-button secondary overlay small icon="camera-reverse" (click)="openCameraSelector($event)"></cs-button>
        }
      </div>

      @if (cameraService.zoomLimits) {
        <cs-button class="zoom-indicator" secondary overlay small [label]="zoomLabel" (click)="resetZoom()"></cs-button>
      }
    }

    @if (isBarcodeMode && !isNative) {
      <cs-barcode-tracker-overlay #trackerOverlay></cs-barcode-tracker-overlay>
    }

    <!-- Projected content: `<cs-barcode-detector>` marker directive (no DOM)
         and any host-owned overlays (e.g. the barcode reticle). -->
    <ng-content></ng-content>
  </div>
}
